(function () {
  window.dataLayer = window.dataLayer || [];
  var CURRENCY = window.GTM_CURRENCY || 'EUR';
  var ATC_URL = /\/cart\/add(\.js)?(\?|$)/;

  function pushAddToCart(data) {
    try {
      var lines = (data && data.items) ? data.items : [data];
      var items = [], total = 0;
      lines.forEach(function (l) {
        if (!l || !l.variant_id) return;
        var price = (l.final_price != null ? l.final_price : l.price) / 100;
        var qty = l.quantity || 1;
        total += price * qty;
        items.push({
          item_id: l.variant_id,
          item_name: l.product_title || l.title,
          item_variant: l.variant_title || '',
          item_brand: l.vendor || '',
          price: price,
          quantity: qty
        });
      });
      if (!items.length) return;
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: { currency: CURRENCY, value: Math.round(total * 100) / 100, items: items }
      });
    } catch (e) {}
  }

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (ATC_URL.test(url)) {
        p.then(function (r) {
          if (r && r.ok) r.clone().json().then(pushAddToCart).catch(function () {});
        }).catch(function () {});
      }
      return p;
    };
  }

  var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this._atcUrl = String(u); return xOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    if (ATC_URL.test(x._atcUrl || '')) {
      x.addEventListener('load', function () {
        if (x.status >= 200 && x.status < 300) { try { pushAddToCart(JSON.parse(x.responseText)); } catch (e) {} }
      });
    }
    return xSend.apply(this, arguments);
  };
})();